import {Injectable} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {ApiResponse} from "../../dtos/api-response";
import {ErrorResponse} from "../../dtos/error-response";
import {SuccessResponse} from "../../dtos/success-response";
import {AuthStorageService} from "../../../utils/auth-storage/auth-storage.service";
import {map} from "rxjs/operators";
import {catchError, throwError} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LogoutApiService {
  private readonly _url = environment.baseApiUrl + '/auth/logout';

  constructor(
    private readonly httpClient: HttpClient,
    private readonly authStorageService: AuthStorageService
  ) {
  }

  logout() {
    return this.httpClient.post<SuccessResponse>(this._url, []).pipe(
      map((response) => {
        return {
          status: 'success',
          data: response.data
        } as ApiResponse;
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMessages: string[] = [];

        if (error.error?.data?.errors) {
          for (const key in error.error.data.errors) {
            if (error.error.data.errors.hasOwnProperty(key)) {
              errorMessages.push(...error.error.data.errors[key]);
            }
          }
        }

        if (errorMessages.length == 0 && error.error?.data?.message) {
          errorMessages.push(error.error.data.message);
        }
        console.log(errorMessages);
        const errorResponse: ErrorResponse = {
          status: 'error',
          data: {
            message: errorMessages,
          }
        };
        return throwError(() => errorResponse);
      })
    );
  }
}
